import { createPageSegmentLoadMetric } from '@confluence/browser-metrics/entry-points/metricConfigs.ts';
import { BLOG_TREE_SEGMENT_KEY } from '@confluence/browser-metrics/entry-points/metric-keys.ts';

export const BLOG_TREE_METRIC = createPageSegmentLoadMetric({
	key: BLOG_TREE_SEGMENT_KEY,
});
